"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptionalText = exports.Input = exports.Label = exports.Wrapper = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const colors_1 = require("../../../theme/colors");
exports.Wrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: ${({ $disabled }) => ($disabled ? "default" : "pointer")};
`;
exports.Label = styled_components_1.default.label `
  margin: 4px 10px 0 8px;
  label {
    color: ${colors_1.GREY4};
    cursor: pointer;
  }

  ${({ $disabled }) => $disabled &&
    (0, styled_components_1.css) `
      label {
        color: ${colors_1.GREY1};
        cursor: default;
      }
    `};
`;
exports.Input = styled_components_1.default.input `
  margin-right: 8px;
  cursor: pointer;
  :after {
    width: 15px;
    height: 15px;
    border-radius: 15px;
    top: -2px;
    left: -1px;
    position: relative;
    background-color: ${colors_1.WHITE};
    content: "";
    display: inline-block;
    visibility: visible;
    border: 1px solid ${colors_1.GREY4};
  }
  :disabled:after {
    border: 1px solid ${colors_1.GREY1};
    cursor: default;
  }
  :checked:after {
    width: 9px;
    height: 9px;
    border-radius: 12px;
    top: -4px;
    left: -3px;
    position: relative;
    background-color: ${colors_1.WHITE};
    content: "";
    display: inline-block;
    visibility: visible;
    border: 6px solid ${colors_1.DARK_GREEN};
  }
  :checked:disabled:after {
    border: 6px solid ${colors_1.GREY1};
    cursor: default;
    background-color: ${colors_1.WHITE};
  }
`;
exports.OptionalText = styled_components_1.default.label `
  margin-top: 4px;
  cursor: pointer;
  color: ${colors_1.GREY3};
`;
//# sourceMappingURL=RadioButton.styles.js.map